/**
 * POST /v1/incidents/:publicId/resolve — params + response.
 */

import { z } from 'zod'

export { IncidentResponseSchema, type IncidentResponse } from './common'

export const ResolveIncidentParamsSchema = z.object({
  publicId: z.string().min(1)
})
export type ResolveIncidentParams = z.infer<typeof ResolveIncidentParamsSchema>
